import { render } from "./Home.vue?vue&type=template&id=64ef5780&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=64ef5780&lang=scss&scoped=true"

import exportComponent from "/root/workspace/__flow_work/__flow_builds/1ac9e6a1-3d63-42f4-aa32-2a0557ce8f53/workspace/wellcee-h5-p_H4zR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ef5780"]])

export default __exports__